// extracted by mini-css-extract-plugin
module.exports = {"fastlinkPanePreset":"FastlinkPane__fastlinkPanePreset__SPAdv","iframe":"FastlinkPane__iframe__g3lMX"};